import React, { useEffect } from 'react';
import "./annexure.css";
import 'bootstrap/dist/css/bootstrap.min.css';
function DisplayHTML({ htmlContent }) {
  return (<div id='div_annexure'><div dangerouslySetInnerHTML={{ __html: htmlContent }}></div></div>);
}

export default DisplayHTML;